import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { useSubscription } from '../../contexts/SubscriptionContext';

interface DisabledButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  reason?: string;
  reasonAr?: string;
  showUpgradeHint?: boolean;
  featureName?: string;
  featureNameAr?: string;
}

const DisabledButton: React.FC<DisabledButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  reason,
  reasonAr,
  showUpgradeHint = true,
  featureName,
  featureNameAr
}) => {
  const { language } = useLocalization();
  const { getCurrentPlan } = useSubscription();
  
  const currentPlan = getCurrentPlan();
  const isFreeUser = currentPlan?.isFreeTier;

  const getTooltipText = () => {
    if (reason || reasonAr) {
      return language === 'ar' ? reasonAr : reason;
    }
    
    if (showUpgradeHint && isFreeUser) {
      const feature = language === 'ar' ? featureNameAr : featureName;
      return language === 'ar' 
        ? `اشترك في الخطة المهنية لاستخدام ${feature || 'هذه الميزة'}`
        : `Subscribe to Professional Plan to use ${feature || 'this feature'}`;
    }
    
    return language === 'ar' ? 'غير متاح في خطتك الحالية' : 'Not available in your current plan';
  };

  return (
    <div className="relative group">
      <button
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        className={`${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        title={disabled ? getTooltipText() : undefined}
      >
        {children}
      </button>
      
      {/* Tooltip */}
      {disabled && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
          {getTooltipText()}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900 dark:border-t-gray-700"></div>
        </div>
      )}
    </div>
  );
};

export default DisabledButton;
